import { isServer, QueryClient } from '@tanstack/react-query'

/** Configuração do QueryClient da loja (a do orbit). A pasta `lib` guarda a inicialização de bibliotecas. */
function makeQueryClient(): QueryClient {
    return new QueryClient({
        defaultOptions: {
            queries: {
                staleTime: 1000 * 60 * 5, // 5 minutos
                gcTime: 1000 * 60 * 30, // 30 minutos (mantém o cache em memória depois do unmount)
                retry: false,
                refetchOnWindowFocus: false,
            },
        },
    })
}

let browserQueryClient: QueryClient | undefined

/**
 * QueryClient da loja, como o TanStack orienta para o App Router: no servidor, um novo por chamada (por requisição; um
 * singleton do processo misturaria o cache de visitantes diferentes); no navegador, sempre o mesmo, para o React não
 * recriar o cache se suspender na primeira renderização.
 */
export function getQueryClient(): QueryClient {
    if (isServer) return makeQueryClient()
    browserQueryClient ??= makeQueryClient()
    return browserQueryClient
}
